import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Router>

    <React.StrictMode>
      <GoogleReCaptchaProvider
        reCaptchaKey={
          process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY ||
          "6Lc1llktAAAAAFZIbG0udmJqLg8EOcowtwSWllDt"
        }
      >
        <App />
      </GoogleReCaptchaProvider>
    </React.StrictMode>
  </Router>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
